import type { FaireProductEntity } from "../../entity_types/product";

export const p_g3n7c27yev: FaireProductEntity = {
  token: "p_g3n7c27yev",
  type: "product",
  name: "Sweet Grace Bath Bomb | Self Care Gift",
  brandToken: "b_be6rwkua52",
  brandName: "Bridgewater Candle Company",
  imageUrl:
    "https://cdn.faire.com/fastly/cf424f32adff420ff36ed392f2b24534eca073db5a4b5f4ea54c8104b9f2f66c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/404ba304993d5136d9b814f24e67b3ef32e49addf08c9dd8cc265c3177c9eeb2.jpeg",
    "https://cdn.faire.com/fastly/dba83db08fc13621f26b4d1f13cf582e45eb47b46a4786e449a77225353f7457.jpeg",
    "https://cdn.faire.com/fastly/467e653721f24d260370145549562899c2129a6605236f5a1e077a2a1a605bfc.jpeg",
    "https://cdn.faire.com/fastly/13926054b0b29fcf682f2cc724d63ff32c45af7191d5ad5f0d725cc3b1337972.jpeg",
    "https://cdn.faire.com/fastly/719582cc10ebe4071c922e566e5a4eeef490b889960e449118e0d018a79ce09b.jpeg",
    "https://cdn.faire.com/fastly/8dd5d475606900fdf7ea83abee3853d6cf24deafd93bb67f2a5b5872456f7fc1.jpeg",
    "https://cdn.faire.com/fastly/780f42b655d37b6f307d839c0a748c40506eac07d24d12db29a166c46fcf3ec3.jpeg",
    "https://cdn.faire.com/fastly/bc89d186c8809f7db48d43571c117c23cdc8aa9e6b1bd5f71656fc3e8c8e9109.jpeg",
  ],
  priceDollars: 4.5,
  description:
    "Sweet Grace Bath Bomb brings our #1 best-selling fragrance into a relaxing self-care essential customers love. Undeniably warm, peaceful, and pure, Sweet Grace blends passionfruit and apricot with sparkling tea, vanilla, caramel, chocolate, and patchouli for a comforting, feel-good fragrance.\n\nPerfect for self-care routines and all-occasion gifting, this bath bomb adds fizzy fun to bath time while filling the tub with the iconic Sweet Grace scent. Ideal for Mother’s Day, Valentine’s Day, birthdays, spa gifts, and everyday pampering, it’s a favorite add-on item retailers love.\n\nEach bath bomb is 5.3 oz and designed for a soothing, indulgent bath experience.",
  tags: [],
  msrpDollars: 9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:26.852Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
